import { normalize } from "../../../utils";

export const searchQueryIsNotEmpty = (searchQuery: string) => {
  return Boolean(searchQuery) && normalize(searchQuery).replace(/[\W_]+/g, '').length >= 3; //Alfresco search constraint
};
